import React from "react";
import {cx} from "../../lib/ClassSet";
import "./DistributionItem.css";

const DistributionItem = (props) => {

  let {data} = props;

  let classes = cx({
    "item": true,
    "shipping-distribution-list-item": true,
    "u-selected": props.selected
  })

  return (
    <tr className={classes} onClick={(e) => props.onClick(data, e)}>
      <td className="field f-id">{data.get("code")}</td>
      <td className="field">{data.get("name")}</td>
      <td className="field f-id f-nolink">{data.get("warehouseId")}</td>
      <td className="field f-id f-nolink">{data.getIn(["warehouseInfo", "system"], "")}</td>
      <td className="field f-id f-nolink">{data.get("shopId")}</td>
    </tr>
  )
}

export default DistributionItem;